<template>
    <div class="row ">
        <div class="col-lg-12 wrap-errors">
            <ul v-if="serverErrors" class="ul-errors">
                <li v-for="(value, key) in serverErrors" :key="key">{{ key }}.  {{ value[0] }}</li>

            </ul>
        </div>
    </div>
</template>

<script>

    export default {
        name: 'errors',
      
        data() {
            return {
                serverErrors: null
            }
        },
        mounted () {
            eventBus.$on('errors', (data) => {
                this.serverErrors = data

          })
        },
        beforeDestroy() {
            eventBus.$off('errors')
        },
    }
</script>

<style>

.ul-errors{padding-left:0px;background-color:#ffe2e4;}
.ul-errors{color:#d27c82;}
.ul-errors {
  margin-bottom: 15px;
  padding: 9px;
  box-shadow: 0px 6px 30px rgba(0,0,0,.1);
  border-left: 3px solid #eab3b7;
  background-color: #ffffff;
}
.ul-errors li {
    font-size: 13px;
    color: #6c757d;
    letter-spacing: 0.5px;
    margin: 0!important;
}


</style>


// WEBPACK FOOTER //
// src/components/app_modules/Errors.vue